import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { ReactComponent as UpmcLogo } from '../../../assets/upmc_primary.svg';
import { ReactComponent as UpmcLogoInverted } from '../../../assets/upmc_primary_inverted.svg';
import styles from './Logo.module.scss';

/**
 * UPMC Logo
 * @returns UPMC Logo component
 */
const Logo = ({ inverted }) => {
	const history = useHistory();
	const propsLogo = {
		onClick: () => history.push('/index.html'),
		alt: 'University of Pittsburgh Medical Center | Identity Management System',
	};

	return (
		<div className={styles.logo}>
			{inverted ? (
				<UpmcLogoInverted {...propsLogo} />
			) : (
				<UpmcLogo {...propsLogo} />
			)}
		</div>
	);
};

Logo.propTypes = {
	inverted: PropTypes.bool,
};

export default Logo;
